export const API_PREFIX = "https://ecommercecartitapi.herokuapp.com/api/";
